import { render, staticRenderFns } from "./Flatpickr.vue?vue&type=template&id=08afb4bb&scoped=true"
import script from "./Flatpickr.vue?vue&type=script&lang=js"
export * from "./Flatpickr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08afb4bb",
  null
  
)

export default component.exports